/* eslint-disable no-unused-expressions */
import './DetailListTree.css';

export const DetailListTree = (props) => {

	const renderQuestionListTree = (questionList) => {
		let tree = [];
		let blocks = questionList.blocksInList;
		blocks.forEach(function (block, index) {
			tree.push(<h3 className='mt-5' key={block.name}>{block.name}</h3>);
			let questions = [];
			let questionsInBlock = block.questionsInBlock;
			questionsInBlock.sort(function (a, b) {
				return a.orderNumber - b.orderNumber;
			});
			questionsInBlock.forEach(function (question, index) {
				questions.push(<li key={question.abbrev}>{(index + 1) + '. ' + question.questionContent}</li>);
			});
			tree.push(<ul className='questions-section' key={'questions-for-' + block.name}>{questions}</ul>);
		});
		return tree;
	};

	return props.questionList ? (
		<>
			{renderQuestionListTree(props.questionList)}
		</>
	) : (<p>Nie ma listy</p>);
};
